<template>
  <div class="container" style="padding-bottom: 20vh; padding-top: 100px;">
    <h1 ref="pageTitle">Events</h1>
    <hr>
    <div style="margin-bottom: 30px; margin-top: 20px;">
      <router-link v-if="!$store.getters.isAuthenticated" :to="{ name: 'Employer Registration' }" class="mylisting-button dark-button" style="text-align: center;">Post an Event</router-link>
    </div>

    <div v-if="listings.length > 0">
      <app-list :listings="listings"></app-list>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import List from './EventList';

  // https://www.npmjs.com/package/vue-loading-overlay
  import Vue from 'vue';
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  // Init plugin
  Vue.use(Loading);

  export default {
    data() {
      return {
        listings: [],
      }
    },
    components: {
      appList: List,
    },
    created() {
      console.log('Event Board Created')
      this.getListings()

      // https://www.npmjs.com/package/vue-loading-overlay
      let loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        // container: this.$refs.formContainer,
        // canCancel: true,
        canCancel: false,
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(() => {
        loader.hide()
      },2000)

      // Scroll the window back up after saving the step
      window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    },
    mounted() {
      document.title = this.$refs.pageTitle.innerHTML
    },
    methods: {
      getListings() {
        axios.get('/api/events/?agency='+this.$store.getters.agencyID.toString())
          .then(res => {
            this.listings = res.data
            console.log(this.listings)

            this.listings = this.listings.sort((a, b) => (a.date > b.date) ? 1 : -1)
            // Only want to show events happening in the future
            var currentEvents = []
            for (var listing in this.listings) {
              if ((new Date(this.listings[listing].date.concat('T00:00:00'))) >= (new Date())) {
                currentEvents.push(this.listings[listing])
              }
            }
            this.listings = currentEvents
          })
          .catch(error => console.log(error))
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/events/EventBoard.vue